import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {TimelineLite} from "gsap";
import {DirtyWildsSoundConfig} from "../DirtyWildsSoundConfig";
import {DirtyWildsGameConfig} from "../DirtyWildsGameConfig";


/**
 * Class description
 *
 * Created: 2017-12-06
 * @author jonas
 */
export class SoundPlayer {
    private _currentMusic:string;
    private _bigWinActive:boolean = false;

    constructor() {}

    public playNormalWinSound(winRatioConfig:IWinRatioConfig) {
        // #231
        if (DirtyWildsGameConfig.instance.WIN_BELOW_STAKE) {
            return;
        }

        let soundName:string = "";
        switch(winRatioConfig.type) {
            case WinRatioType.TINY:
                soundName = DirtyWildsSoundConfig.TINY_WIN;
                break;
            case WinRatioType.SMALL:
                soundName = DirtyWildsSoundConfig.SMALL_WIN;
                break;
            case WinRatioType.MEDIUM:
                soundName = DirtyWildsSoundConfig.MEDIUM_WIN;
                break;
            case WinRatioType.LARGE:
                soundName = DirtyWildsSoundConfig.LARGE_WIN;
                break;
            case WinRatioType.BIG_WIN:
            case WinRatioType.MEGA_WIN:
            case WinRatioType.SUPER_MEGA_WIN:
                soundName = DirtyWildsSoundConfig.BIG_WIN_START;
                break;
            default:
                soundName = "";
                break;
        }
        SlotGame.sound.playEffect(soundName);

    }

    public switchToFreespinMusic(fadeOut:boolean = false) {
        if(this._currentMusic == DirtyWildsSoundConfig.instance.RESPIN_GAME_AMBIANCE) {
            return;
        }
        const tl:TimelineLite = new TimelineLite({
            onComplete : () => {
                if(fadeOut) {
                    SlotGame.sound.fadeAmbience(0, 0);
                }
            }
        });
        tl.add(() => SlotGame.sound.playAmbience(DirtyWildsSoundConfig.instance.RESPIN_GAME_AMBIANCE));
        this._currentMusic = DirtyWildsSoundConfig.instance.RESPIN_GAME_AMBIANCE;
    }

    public switchToMainMusic(fadeOut:boolean = false) {
        if(this._currentMusic == DirtyWildsSoundConfig.instance.MAIN_GAME_AMBIANCE) {
            return;
        }
        const tl:TimelineLite = new TimelineLite({
            onComplete : () => {
                if(fadeOut) {
                    SlotGame.sound.fadeAmbience(0, 0);
                }
            }
        });
        tl.add(() => SlotGame.sound.playAmbience(DirtyWildsSoundConfig.instance.MAIN_GAME_AMBIANCE));
        this._currentMusic = DirtyWildsSoundConfig.instance.MAIN_GAME_AMBIANCE;
    }


    startBigWinLoop() {
        if(!this._bigWinActive) {
            // this.fadeLoop(0, 200);
            SlotGame.sound.playEffect(DirtyWildsSoundConfig.BIG_WIN_MUSIC_LOOP);
            this._bigWinActive = true;
        }
    }

    stopBigWinLoop(name:string) {
        SlotGame.sound.fadeAmbience(1, 2000);
        SlotGame.sound.stopEffect(DirtyWildsSoundConfig.BIG_WIN_MUSIC_LOOP);
        SlotGame.sound.playEffect(name);
        this._bigWinActive = false;
    }
}